<template>
  <div class="application_form">
    <template v-if="isShowBtn">
      <el-form :model="query" ref="form" :rules="rules" label-width="90px">
        <el-row>
          <el-col :span="6">
            <el-form-item label="赛事名称" prop="raceName">
              <el-select
                :popper-append-to-body="false"
                style="width:300px"
                v-model="query.raceName"
                placeholder="请选择赛事"
                @change="selectMatch"
              >
                <el-option
                  v-for="(item,index) in matchList"
                  :key="index"
                  :value="item.id"
                  :label="item.name"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- <template v-if="(publishState === 0  || publishState == 2) && query.raceName">
            <el-col :span="4.5" style="margin:0 40px">
              <el-form-item label="运动员范围">
                <el-select
                  :popper-append-to-body="false"
                  style="width:200px"
                  v-model="scopeAthlete"
                  @change="selectAthleteType"
                >
                  <el-option value="all" label="全校"></el-option>
                  <el-option value="swim" label="游泳"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item label="教练员范围">
                <el-select
                  :popper-append-to-body="false"
                  style="width:200px"
                  v-model="scopeCoach"
                  @change="selectCoachType"
                >
                  <el-option value="all" label="全校"></el-option>
                  <el-option value="swim" label="游泳"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </template>-->
        </el-row>
      </el-form>
      <el-table style="width:100%;margin-top:40px" border :data="tableData">
        <el-table-column label="序号" align="center" width="60">
          <template slot-scope="{row,$index}">
            <div @click="addTable" style="cursor:pointer" v-if="row.isAdd">+</div>
            <template v-else>{{$index + 1}}</template>
          </template>
        </el-table-column>
        <el-table-column
          label="单位"
          align="center"
          width="100"
          prop="schoolName"
          :formatter="stateFormat"
        ></el-table-column>
        <el-table-column label="身份" align="center" width="100">
          <template slot-scope="{row,column,$index}">
            <div
              v-if="publishState === 0 || publishState === 2"
              class="table_select_box"
              style="display:flex;align-items:center;justify-content:center;height:30px"
              @click.stop="{{changeNum($index,'identity','editRemarkInput')}}"
            >
              <el-select
                @change="$event=>selectIdentity($event,$index)"
                style="height:30px"
                v-if="editable[$index].identity"
                v-model="row.identity"
                filterable
                clearable
                size="mini"
                @blur="$event=>handleBlur($event,$index,'identity')"
                class="editRemarkInput"
              >
                <el-option
                  v-for="(item,index) in identityList"
                  :key="index"
                  :value="item.value"
                  :label="item.label"
                ></el-option>
              </el-select>
              <template v-else>{{getIdentity(row.identity)}}</template>
            </div>
            <span v-else>{{getIdentity(row.identity)}}</span>
          </template>
        </el-table-column>
        <el-table-column label="兼任" align="center" width="100">
          <template slot-scope="{row,column,$index}">
            <div
              v-if="publishState === 0 || publishState === 2"
              class="table_select_box"
              style="display:flex;align-items:center;justify-content:center;height:30px"
              @click.stop="{{changeNum($index,'partTime','editRemarkInput')}}"
            >
              <el-select
                style="height:30px"
                v-if="editable[$index].partTime"
                v-model="row.partTime"
                filterable
                size="mini"
                @blur="$event=>handleBlur($event,$index,'partTime')"
                class="editRemarkInput"
              >
                <el-option value="FALSE" label="FALSE"></el-option>
                <el-option value="TRUE" label="TRUE"></el-option>
              </el-select>
              <template v-else>{{row.partTime}}</template>
            </div>
            <template v-else>{{row.partTime}}</template>
          </template>
        </el-table-column>
        <el-table-column label="性别" align="center" width="60">
          <template slot-scope="{row,column,$index}">
            <div
              v-if="publishState === 0 || publishState === 2"
              class="table_select_box"
              style="display:flex;align-items:center;justify-content:center;height:30px"
              @click.stop="{{changeNum($index,'gender','editRemarkInput')}}"
            >
              <el-select
                @change="$event=>selectGender($event,$index,'gender')"
                style="height:30px"
                v-if="editable[$index].gender"
                v-model="row.gender"
                clearable
                filterable
                size="mini"
                @blur="$event=>handleBlur($event,$index,'gender')"
                class="editRemarkInput"
              >
                <el-option
                  v-for="(item,index) in genderList"
                  :value="item.value"
                  :label="item.label"
                  :key="index"
                ></el-option>
              </el-select>
              <span v-else>{{row.gender}}</span>
            </div>
            <span v-else>{{row.gender}}</span>
          </template>
        </el-table-column>
        <el-table-column label="组别" align="center" width="60">
          <template slot-scope="{row,column,$index}">
            <div
              v-if="publishState === 0 || publishState === 2"
              class="table_select_box"
              style="display:flex;align-items:center;justify-content:center;height:30px"
              @click.stop="{{changeNum($index,'group','editRemarkInput')}}"
            >
              <el-select
                style="height:30px"
                v-if="editable[$index].group"
                v-model="row.group"
                clearable
                filterable
                size="mini"
                @blur="$event=>handleBlur($event,$index,'group')"
                class="editRemarkInput"
              >
                <el-option
                  v-for="(item,index) in groupList"
                  :value="item.value"
                  :label="item.label"
                  :key="index"
                ></el-option>
              </el-select>
              <template v-else>{{row.group}}</template>
            </div>
            <template v-else>{{row.group}}</template>
          </template>
        </el-table-column>
        <el-table-column label="姓名" align="center" width="100">
          <template slot-scope="{row,column,$index}">
            <div
              v-if="publishState === 0 || publishState === 2"
              class="table_select_box"
              style="display:flex;align-items:center;justify-content:center;min-height:30px"
              @click.stop="{{changeNum($index,'name','editRemarkInput')}}"
            >
              <!-- <el-select
                @change="$event=>selectAthlete($event,$index,'name')"
                style="height:30px"
                v-if="editable[$index].name && (tableData[$index].identity !== 2 && tableData[$index].identity !== 3 && tableData[$index].identity !== 4 && tableData[$index].identity !== 5)"
                v-model="row.name"
                clearable
                filterable
                size="mini"
                @blur="$event=>handleBlur($event,$index,'name')"
                class="editRemarkInput"
              >
                <el-option
                  :disabled="item.disabled"
                  v-for="item in athleteList"
                  :key="item.id"
                  :value="item.id"
                  :label="item.name"
                ></el-option>
              </el-select>-->
              <el-input
                v-model="row.name"
                size="mini"
                maxlength="4"
                @blur="$event=>handleBlur($event,$index,'name')"
                class="editRemarkInput"
                v-if="editable[$index].name && (tableData[$index].identity === 2 || tableData[$index].identity === 3 || tableData[$index].identity === 4 || tableData[$index].identity === 5)"
              ></el-input>
              <div class="cell" v-else>{{row.name}}</div>
            </div>
            <span v-else>{{row.name}}</span>
          </template>
        </el-table-column>
        <el-table-column label="姓名全拼" align="center" width="160">
          <template slot-scope="{row,column,$index}">
            <div
              v-if="publishState === 0 || publishState === 2"
              style="display:flex;align-items:center;justify-content:center;min-height:30px"
              @click.stop="{{changeNum($index,'pinyin','editRemarkInput')}}"
            >
              <el-input
                maxlength="30"
                v-if="editable[$index].pinyin"
                v-model.trim="row.pinyin"
                size="mini"
                @blur="$event=>handleBlur($event,$index,'pinyin')"
                class="editRemarkInput"
              ></el-input>
              <span v-else>{{row.pinyin}}</span>
            </div>
            <span v-else>{{row.pinyin}}</span>
          </template>
        </el-table-column>
        <el-table-column label="身份证号码" align="center" width="160">
          <template slot-scope="{row,column,$index}">
            <div
              v-if="publishState === 0 || publishState === 2"
              style="display:flex;align-items:center;justify-content:center;min-height:30px"
              @click.stop="{{changeNum($index,'idCard','editRemarkInput')}}"
            >
              <el-input
                maxlength="10"
                v-if="editable[$index].idCard"
                v-model.trim="row.idCard"
                size="mini"
                @blur="$event=>handleBlur($event,$index,'idCard')"
                class="editRemarkInput"
              ></el-input>
              <span v-else>{{row.idCard}}</span>
            </div>
            <span v-else>{{row.idCard}}</span>
          </template>
        </el-table-column>
        <el-table-column label="出生日期" align="center" width="110">
          <template slot-scope="{row,column,$index}">
            <div
              v-if="publishState === 0 || publishState === 2"
              style="display:flex;align-items:center;justify-content:center;min-height:30px"
              @click.stop="{{changeNum($index,'birthday','editRemarkInput')}}"
            >
              <el-date-picker
                size="mini"
                v-if="editable[$index].birthday"
                v-model="row.birthday"
                value-format="yyyy-MM-dd"
                type="date"
                class="editRemarkInput"
                @blur="$event=>handleBlur($event,$index,'birthday')"
                placeholder="选择日期"
              ></el-date-picker>
              <span v-else>{{row.birthday}}</span>
            </div>
            <span v-else>{{row.birthday}}</span>
          </template>
        </el-table-column>
        <el-table-column label="注册号码" align="center" width="140">
          <template slot-scope="{row,column,$index}">
            <div
              v-if="publishState === 0 || publishState === 2"
              style="display:flex;align-items:center;justify-content:center;min-height:30px"
              @click.stop="{{changeNum($index,'registerNumber','editRemarkInput')}}"
            >
              <el-input
                maxlength="10"
                v-if="editable[$index].registerNumber"
                v-model.trim="row.registerNumber"
                size="mini"
                @blur="$event=>handleBlur($event,$index,'registerNumber')"
                class="editRemarkInput"
              ></el-input>
              <span v-else>{{row.registerNumber}}</span>
            </div>
            <span v-else>{{row.registerNumber}}</span>
          </template>
        </el-table-column>
        <el-table-column label="比赛号" align="center" width="100" prop="matchNumber"></el-table-column>
        <el-table-column label="分计单位" align="center" width="100" prop="subUnit"></el-table-column>
        <el-table-column label="教练" align="center" width="80">
          <template slot-scope="{row,column,$index}">
            <div
              v-if="publishState === 0 || publishState === 2"
              class="table_select_box"
              style="display:flex;align-items:center;justify-content:center;height:30px"
              @click.stop="{{changeNum($index,'coachId','editRemarkInput')}}"
            >
              <!-- <el-select
                style="height:30px"
                v-if="editable[$index].coachId"
                v-model="row.coachId"
                clearable
                filterable
                size="mini"
                @blur="$event=>handleBlur($event,$index,'coachId')"
                class="editRemarkInput"
              >
                <el-option
                  v-for="(item,index) in coachList"
                  :key="index"
                  :value="item.id"
                  :label="item.name"
                ></el-option>
              </el-select>-->
              <span>{{getCoachName(row.coachId) || row.coachName}}</span>
            </div>
            <span v-else>{{getCoachName(row.coachId) || row.coachName}}</span>
          </template>
        </el-table-column>
        <el-table-column label="备注" width="80" align="center" prop="remarks">
          <template slot-scope="{row,column,$index}">
            <div
              v-if="publishState === 0 || publishState === 2"
              style="display:flex;align-items:center;justify-content:center;min-height:30px"
              @click.stop="{{changeNum($index,'remarks','editRemarkInput')}}"
            >
              <el-input
                maxlength="10"
                v-if="editable[$index].remarks"
                v-model.trim="row.remarks"
                size="mini"
                @blur="$event=>handleBlur($event,$index,'remarks')"
                class="editRemarkInput"
              ></el-input>
              <span class="show_limmit" v-else>{{row.remarks}}</span>
            </div>
            <span class="show_limmit" v-else>{{row.remarks}}</span>
          </template>
        </el-table-column>
        <el-table-column label="距离" width="80" align="center">
          <template slot-scope="{row,column,$index}">
            <div
              v-if="publishState === 0 || publishState === 2"
              class="table_select_box"
              style="display:flex;align-items:center;justify-content:center;height:30px"
              @click.stop="{{changeNum($index,'distance','editRemarkInput')}}"
            >
              <el-select
                @change="$event=>selectDistance($event,$index)"
                style="height:30px"
                v-if="editable[$index].distance"
                v-model="row.distance"
                clearable
                filterable
                size="mini"
                @blur="$event=>handleBlur($event,$index,'distance')"
                class="editRemarkInput"
              >
                <el-option
                  v-for="(item,index) in distanceList"
                  :key="index"
                  :value="item.value"
                  :label="item.label"
                ></el-option>
              </el-select>
              <span v-else>{{row.distance}}</span>
            </div>
            <span v-else>{{row.distance}}</span>
          </template>
        </el-table-column>
        <el-table-column label="泳式" width="100" align="center">
          <template slot-scope="{row,column,$index}">
            <div
              v-if="publishState === 0 || publishState === 2"
              class="table_select_box"
              style="display:flex;align-items:center;justify-content:center;height:30px"
              @click.stop="{{changeNum($index,'swimmingStyle','editRemarkInput')}}"
            >
              <el-select
                @change="$event=>selectSwimmingStyle($event,$index)"
                style="height:30px"
                v-if="editable[$index].swimmingStyle"
                v-model="row.swimmingStyle"
                clearable
                filterable
                size="mini"
                @blur="$event=>handleBlur($event,$index,'swimmingStyle')"
                class="editRemarkInput"
              >
                <el-option
                  v-for="(item,index) in swimmingStyleList"
                  :key="index"
                  :value="item.value"
                  :label="item.label"
                ></el-option>
              </el-select>
              <span v-else>{{row.swimmingStyle}}</span>
            </div>
            <span v-else>{{row.swimmingStyle}}</span>
          </template>
        </el-table-column>
        <el-table-column label="报名成绩" width="80" align="center">
          <template slot-scope="{row,column,$index}">
            <div
              v-if="publishState === 0 || publishState === 2"
              style="display:flex;align-items:center;justify-content:center;min-height:30px"
              @click.stop="{{changeNum($index,'score','editRemarkInput')}}"
            >
              <el-input
                maxlength="10"
                v-if="editable[$index].score"
                v-model.trim="row.score"
                size="mini"
                @blur="$event=>handleBlur($event,$index,'score')"
                class="editRemarkInput"
              ></el-input>
              <span v-else>{{row.score}}</span>
            </div>
            <span v-else>{{row.score}}</span>
          </template>
        </el-table-column>
        <el-table-column label="测验" width="80" align="center">
          <template slot-scope="{row,column,$index}">
            <div
              v-if="publishState === 0 || publishState === 2"
              class="table_select_box"
              style="display:flex;align-items:center;justify-content:center;height:30px"
              @click.stop="{{changeNum($index,'test','editRemarkInput')}}"
            >
              <el-select
                style="height:30px"
                v-if="editable[$index].test"
                v-model="row.test"
                clearable
                filterable
                size="mini"
                @blur="$event=>handleBlur($event,$index,'test')"
                class="editRemarkInput"
              >
                <el-option value="FALSE" label="FALSE"></el-option>
                <el-option value="TRUE" label="TRUE"></el-option>
              </el-select>
              <span v-else>{{row.test}}</span>
            </div>
            <span v-else>{{row.test}}</span>
          </template>
        </el-table-column>
        <el-table-column label="特殊标记" width="80" align="center">
          <template slot-scope="{row,column,$index}">
            <div
              v-if="publishState === 0 || publishState === 2"
              class="table_select_box"
              style="display:flex;align-items:center;justify-content:center;height:30px"
              @click.stop="{{changeNum($index,'mark','editRemarkInput')}}"
            >
              <el-select
                style="height:30px"
                v-if="editable[$index].mark"
                v-model="row.mark"
                clearable
                filterable
                size="mini"
                @blur="$event=>handleBlur($event,$index,'mark')"
                class="editRemarkInput"
              >
                <el-option value="FALSE" label="FALSE"></el-option>
                <el-option value="TRUE" label="TRUE"></el-option>
              </el-select>
              <span v-else>{{row.mark}}</span>
            </div>
            <span v-else>{{row.mark}}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="100" align="center">
          <template slot-scope="{row,$index}">
            <el-button
              v-if="!row.isAdd && (publishState !== 1 && publishState !== 3)"
              type="text"
              style="color:rgb(252, 91, 91);"
              @click="deleteRow($index)"
            >删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <footer v-if="publishState === 0 || publishState === 2">
        <template v-if="query.matchId">
          <el-button
            :loading="loadingData.submitLoading"
            class="btns"
            @click="submits('submit')"
          >确认提交</el-button>
          <el-button
            :loading="loadingData.saveLoading"
            class="btns"
            @click="submits('save')"
            style="margin:0 20px;"
          >保存草稿</el-button>
          <el-button class="btns" @click="clearData">清空重置</el-button>
        </template>
      </footer>
      <footer v-else>
        <span style="font-size:22px">审核状态：</span>
        <span
          :style="{color:publishState === 1?'#1E63B0':'#1CC28C'}"
          style="font-size:18px"
        >{{publishState === 1?'待审核':'审核已通过'}}</span>
      </footer>
    </template>
    <template v-else>
      <div style="padding:160px 0 0 250px">
        <img src="../../assets/img/signUp/no_data.png" alt />
      </div>
    </template>
    <div
      v-if="!hideMask"
      style="width:100%;height:100vh;position:fixed;background:#fff;top:106px;z-index:999999;left:290px;"
    ></div>
    <el-dialog title="提示" center :visible.sync="dialogVisible" width="30%">
      <p v-if="blankAthleteNames" :style="{paddingBottom:!blankAthleteName?'40px':'0'}" style="padding:40px 0 0;font-size:16px;text-align:center;line-height:24px">
        运动员<span style="color:red;">{{blankAthleteNames}}</span>未选择教练；
      </p>
      <p v-if="blankAthleteName" :style="{paddingTop:!blankAthleteNames?'40px':'0',marginTop:blankAthleteNames?'20px':'0'}" style="padding:0 0 40px;font-size:16px;text-align:center;line-height:24px;">
        运动员<span style="color:red;">{{blankAthleteName}}</span>比赛项目为空白，请确认是否继续?
      </p>
      <span slot="footer" class="dialog-footer" style="padding-bottom:40px">
        <el-button type="primary" style="width:70px;margin-right:20px;" @click="confirms">确 定</el-button>
        <el-button @click="dialogVisible = false" style="width:70px;">取 消</el-button>
      </span>
    </el-dialog>
    <el-dialog :title="showDialog.title" center width="800px" :visible.sync="showDialog.isShow">
      <div class="athlete_range" v-if="showDialog.type == 1">
        <div class="heads">
          <span>运动员范围</span>
          <el-select
            :popper-append-to-body="false"
            style="width:200px"
            v-model="scopeAthlete"
            @change="selectAthleteType"
          >
            <el-option value="all" label="全校"></el-option>
            <el-option value="swim" label="游泳"></el-option>
          </el-select>
        </div>
        <div class="radio_group">
          <el-radio-group v-model="athletes">
            <ul v-for="(t,i) in athleteNumber" :key="i">
              <li
                v-for="(item,index) in athleteList.slice(i * 5,(i + 1) * 5)"
                :key="i + '_' + index"
              >
                <el-radio :label="item.id">{{item.name}}</el-radio>
              </li>
            </ul>
          </el-radio-group>
        </div>
      </div>
      <div class="coach_range" v-else>
        <div class="heads">
          <span>教练员范围</span>
          <el-select
            :popper-append-to-body="false"
            style="width:200px"
            v-model="scopeCoach"
            @change="selectCoachType"
          >
            <el-option value="all" label="全校"></el-option>
            <el-option value="swim" label="游泳"></el-option>
          </el-select>
        </div>
        <div class="radio_group">
          <el-radio-group v-model="coachs">
            <ul v-for="(t,i) in coachNumber" :key="i">
              <li v-for="(item,index) in coachList.slice(i * 5,(i + 1) * 5)" :key="i + '_' + index">
                <el-radio @click.native.prevent="clickitem(item.id)" :label="item.id">{{item.name}}</el-radio>
              </li>
            </ul>
          </el-radio-group>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" style="width:70px;margin-right:20px;" @click="confirmAthlete">确 定</el-button>
        <el-button @click="showDialog.isShow = false" style="width:70px;">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { getSignDetailBySchool } from "@/api/sign-up-match";
import { getMatchList } from "@/api/sports-management";
import { table, message } from "@/common/js/mixins";
import { getSession } from "@/utils/storage.js";
import { getCoachList, getAthleteList } from "@/api/athletes.js";
import { addSwimming, updateSwimming } from "@/api/swimming.js";
export default {
  mixins: [table, message],
  data() {
    return {
      tipCoachList:[],
      tipType: false,
      showCoachTip:false,
      query: {
        raceName: "",
        matchId: "",
        id: ""
      },
      athletes: "",
      coachs: "",
      showDialog: {
        isShow: false,
        title: "",
        type: 1
      },
      submitType: "",
      dialogVisible: false,
      scopeAthlete: "all",
      scopeCoach: "all",
      blankArray: [],
      genderList: [
        {
          label: "男子",
          value: "男子"
        },
        {
          label: "女子",
          value: "女子"
        },
        {
          label: "男女",
          value: "男女"
        }
      ],
      groupList: [],
      identityList: [
        {
          label: "领队",
          value: 3
        },
        {
          label: "教练",
          value: 2
        },
        {
          label: "工作人员",
          value: 4
        },
        {
          label: "医生",
          value: 5
        },
        {
          label: "运动员",
          value: 1
        },
        {
          label: "代表队",
          value: 6
        }
      ],
      loadingData: {
        submitLoading: false,
        saveLoading: false
      },
      tableRow: "",
      userInfo: JSON.parse(getSession("userInfo")),
      publishState: 0,
      hideMask: false,
      isShowBtn: true,
      matchList: [],
      athleteList: [],
      coachList: [],
      swimmingStyleList: [
        {
          label: "自由泳",
          value: "自由泳"
        },
        {
          label: "仰泳",
          value: "仰泳"
        },
        {
          label: "蛙泳",
          value: "蛙泳"
        },
        {
          label: "蝶泳",
          value: "蝶泳"
        },
        {
          label: "个人混合泳",
          value: "个人混合泳"
        },
        {
          label: "自由泳接力",
          value: "自由泳接力"
        },
        {
          label: "混合泳接力",
          value: "混合泳接力"
        }
      ],
      distanceList: [
        {
          label: "50米",
          value: "50米"
        },
        {
          label: "100米",
          value: "100米"
        },
        {
          label: "200米",
          value: "200米"
        },
        {
          label: "400米",
          value: "400米"
        },
        {
          label: "800米",
          value: "800米"
        },
        {
          label: "1500米",
          value: "1500米"
        },
        {
          label: "4X50米",
          value: "4X50米"
        },
        {
          label: "4X100米",
          value: "4X100米"
        },
        {
          label: "4X200米",
          value: "4X200米"
        }
      ],
      currentProject: {},
      titles: [
        "identity",
        "partTime",
        "gender",
        "group",
        "name",
        "pinyin",
        "idCard",
        "birthday",
        "registerNumber",
        "coachId",
        "remarks",
        "distance",
        "swimmingStyle",
        "score",
        "test",
        "mark"
      ],
      tableData: [],
      editable: [],
      rules: {
        raceName: [
          {
            required: true,
            message: "赛事名称不能为空",
            trigger: "blur"
          }
        ]
      }
    };
  },
  computed: {
    //
    athleteNumber() {
      if (this.athleteList.length < 5) {
        return 1;
      } else {
        return this.athleteList.length % 5 == 0
          ? this.athleteList.length / 5
          : parseInt(this.athleteList.length / 5) + 1;
      }
    },
    //
    coachNumber() {
      if (this.coachList.length < 5) {
        return 1;
      } else {
        return this.coachList.length % 5 == 0
          ? this.coachList.length / 5
          : parseInt(this.coachList.length / 5) + 1;
      }
    },
    // 泳式、距离为空白的运动员名称
    blankAthleteName() {
      if (this.blankArray.length > 0) {
        return this.blankArray
          .map(item => {
            return item.name;
          })
          .join(",");
      }
      return "";
    },
    // 教练未空白的运动员名称
    blankAthleteNames() {
      if (this.tipCoachList.length > 0) {
        return this.tipCoachList
          .map(item => {
            return item.name;
          })
          .join(",");
      }
      return "";
    },
    // 获取教练员名称
    getCoachName() {
      return data => {
        let coachName = "";
        this.coachList.filter(item => {
          if (item.id === data) {
            coachName = item.name;
          }
        });
        return coachName;
      };
    },
    // 获取身份名称
    getIdentity() {
      return data => {
        let identityName = "";
        this.identityList.filter(item => {
          if (item.value === data) identityName = item.label;
        });
        return identityName;
      };
    }
  },
  methods: {
    // 教练选择单击取消
    clickitem(e) {
      e === this.coachs ? (this.coachs = "") : (this.coachs = e);
    },
    // 确认选择运动员
    confirmAthlete() {
      if (this.showDialog.type == 1) {
        if (!this.athletes) {
          return this.openWarn("请至少选择一位运动员！");
        }
        Object.assign(this.tableData[this.tableRow], {
          athleteId: this.athletes
        });
        this.selectAthlete(this.athletes, this.tableRow, "name", true);
      } else {
        Object.assign(this.tableData[this.tableRow], {
          coachId: this.coachs,
          coachName: this.getCoachName(this.coachs)
        });
      }

      this.showDialog.isShow = false;
    },
    // 弹窗提示确定事件
    confirms() {
      this.dialogVisible = false;
      this.submits(this.submitType, "pass");
    },
    // 根据运动员类型 获取全校/游泳 运动员列表
    selectAthleteType(e) {
      // this.tableData.filter((item, index) => {
      //   if (item.identity === 1) {
      //     Object.assign(this.tableData[index], {
      //       athleteId: "",
      //       gender: "",
      //       name: "",
      //       pinyin: "",
      //       idCard: "",
      //       birthday: "",
      //       registerNumber: ""
      //     });
      //   }
      // });
      getAthleteList({
        pageNo: 1,
        pageSize: 999,
        effective: 1,
        isPass: 1,
        isOld: 0,
        project: this.scopeAthlete == "all" ? null : 4,
        gender:
          this.currentProject.gender === -1 ? "" : this.currentProject.gender
      })
        .then(res => {
          if (res.list.length === 0) {
            this.openWarn("当前组别无运动员数据");
          }
          res.list.filter(item => {
            item.disabled = false;
          });
          this.athleteList = [...res.list];
        })
        .catch(err => {});
    },
    // 根据教练员类型 获取全校/游泳 教练员列表
    selectCoachType(e) {
      // this.tableData.filter((item, index) => {
      //   if (item.identity === 1) {
      //     Object.assign(this.tableData[index], {
      //       coachId: ""
      //     });
      //   }
      // });
      this.getCoachLists();
    },
    // 删除表格列
    deleteRow(index) {
      this.tableData.splice(index, 1);
    },
    stateFormat(row, column, cellValue) {
      if (!cellValue) return "";
      if (cellValue.length > 4) {
        //最长固定显示10个字符
        return cellValue.slice(0, 4) + "...";
      }
      return cellValue;
    },
    // 添加表格行
    addTable() {
      const obj = {
        isAdd: false,
        schoolName: this.userInfo.schoolName,
        athleteId: "",
        identity: "",
        partTime: "FALSE",
        gender: "",
        group: "",
        name: "",
        pinyin: "",
        idCard: "",
        birthday: "",
        registerNumber: "",
        matchNumber: "",
        subUnit: "",
        coachId: "",
        remarks: "",
        distance: "",
        swimmingStyle: "",
        score: "99:99.99",
        test: "FALSE",
        mark: "FALSE"
      };

      this.tableData.splice(this.tableData.length - 1, 0, obj);
      let objs = {};
      this.titles.filter(temp => {
        objs[temp] = false;
      });
      this.editable.splice(this.editable.length - 1, 0, objs);
    },
    // 提交/草稿
    submits(type, pass = null) {
      let data = this.formData(type, pass);
      if (!data) return;
      if (!this.query.id) {
        this.loadingData.submitLoading = true;
        addSwimming({
          ...this.query,
          ...data,
          state: type === "submit" ? 1 : 0
        })
          .then(res => {
            this.loadingData.submitLoading = false;

            this.openSuccess(
              type === "submit" ? "恭喜你，报名成功！" : "保存成功！"
            );

            this.$router.push({
              path: "/swimming/swimming-registration-form-view",
              query: {
                id: this.query.raceName
              }
            });
          })
          .catch(err => {
            this.loadingData.submitLoading = false;
          });
      } else {
        if (type === "submit") this.loadingData.submitLoading = true;
        else this.loadingData.saveLoading = true;
        updateSwimming({
          ...this.query,
          ...data,
          state: type === "submit" ? 1 : 0
        })
          .then(res => {
            if (type === "submit") this.loadingData.submitLoading = false;
            else this.loadingData.saveLoading = false;

            this.openSuccess(
              type === "submit" ? "恭喜你，报名成功！" : "保存成功！"
            );

            this.$router.push({
              path: "/swimming/swimming-registration-form-view",
              query: {
                id: this.query.raceName
              }
            });
          })
          .catch(err => {
            if (type === "submit") this.loadingData.submitLoading = false;
            else this.loadingData.saveLoading = false;
          });
      }
    },
    // 格式化数据
    formData(type, pass) {
      let athleteJson = [];
      let flag = false;
      let num = 0;
      let warnText = "";
      let openDialog = false;
      /**
       * 注：不管什么身份，比赛号及分计单位均为空白
       * 判断1：表格中所有数据均为初始项（无填入）时给与提示
       * 判断2：表格中身份为领队、教练、工作人员、医生时，判断性别及姓名是否填入，无填入则给予提示
       * 判断3：表格中身份为运动员时，均要填入，若某项没有填入，给与提示
       * 判断4：表格中身份为代表队时，判断性别、组别、距离、泳式、报名成绩是否填入，无填入则给与提示
       */
      this.tableData.forEach(item => {
        if (!flag) {
          if (!item.identity) num++;
          else {
            switch (item.identity) {
              case 2:
              case 3:
              case 4:
              case 5: {
                if (!item.gender) {
                  warnText = "请选择性别后进行操作";
                  flag = true;
                  return;
                }
                if (!item.name) {
                  warnText = "请输入姓名后进行操作";
                  flag = true;
                  return;
                }
                athleteJson.push({
                  identity: item.identity,
                  partTime: item.partTime,
                  gender: item.gender,
                  name: item.name,
                  pinyin: item.pinyin,
                  subUnit: item.subUnit,
                  remarks: item.remarks,
                  matchNumber: item.matchNumber,
                  mark: item.mark,
                  test: item.test
                });
                return;
              }
              case 6: {
                if (!item.gender) {
                  warnText = "请选择性别后进行操作";
                  flag = true;
                  return;
                }
                if (!item.group) {
                  warnText = "请选择组别后进行操作";
                  flag = true;
                  return;
                }
                if (!item.distance) {
                  warnText = "请选择距离后进行操作";
                  flag = true;
                  return;
                }
                if (!item.swimmingStyle) {
                  warnText = "请选择泳式后进行操作";
                  flag = true;
                  return;
                }
                athleteJson.push({
                  identity: item.identity,
                  partTime: item.partTime,
                  gender: item.gender,
                  group: item.group,
                  subUnit: item.subUnit,
                  matchNumber: item.matchNumber,
                  remarks: item.remarks,
                  distance: item.distance,
                  swimmingStyle: item.swimmingStyle,
                  score: item.score,
                  mark: item.mark,
                  test: item.test
                });
                return;
              }
              case 1: {
                if (!item.athleteId) {
                  warnText = "请选择姓名后进行操作";
                  flag = true;
                  return;
                }
                if (!item.gender) {
                  warnText = "请选择性别后进行操作";
                  flag = true;
                  return;
                }
                if (!item.group) {
                  warnText = "请选择组别后进行操作";
                  flag = true;
                  return;
                }
                if (!item.distance && item.swimmingStyle) {
                  warnText = "请选择距离后进行操作";
                  flag = true;
                  return;
                }
                if (!item.swimmingStyle && item.distance) {
                  warnText = "请选择泳式后进行操作";
                  flag = true;
                  return;
                }
                if (!pass) {
                  if (!item.coachId) {
                    flag = true;
                    openDialog = true;
                    this.showCoachTip = true;
                    return;
                  } else {
                    this.showCoachTip = false;
                    openDialog = true;
                  }
                  if (!item.distance && !item.swimmingStyle) {
                    flag = true;
                    openDialog = true;
                    this.tipType = true;
                    return;
                  } else {
                    this.tipType = false;
                    openDialog = false;
                  }
                }

                athleteJson.push({
                  identity: item.identity,
                  partTime: item.partTime,
                  gender: item.gender,
                  group: item.group,
                  name: item.name,
                  athleteId: item.athleteId,
                  subUnit: item.subUnit,
                  matchNumber: item.matchNumber,
                  coachId: item.coachId,
                  remarks: item.remarks,
                  distance: item.distance,
                  swimmingStyle: item.swimmingStyle,
                  score: item.score,
                  mark: item.mark,
                  test: item.test
                });
                return;
              }
            }
          }
        }
      });
      if (num === this.tableData.length) {
        return this.openWarn("请至少添加一个身份");
      }
      if (openDialog) {
        this.findAthlete(type);
        this.dialogVisible = true;
        return;
      }
      if (warnText) return this.openWarn(warnText);
      return {
        athleteJson: JSON.stringify(athleteJson)
      };
    },
    // 找出距离，泳式为空白的运动员
    findAthlete(type) {
      this.blankArray = [];
      this.tipCoachList = [];
      this.tableData.filter(item => {
        if (item.identity == 1 && !item.distance && !item.swimmingStyle) {
          this.blankArray.push(item);
        }
        if(item.identity == 1 && !item.coachId) {
          this.tipCoachList.push(item);
        }
      });
      this.submitType = type;
    },
    // 清空重置
    clearData() {
      this.tableData.filter((item, index) => {
        for (let temp in item) {
          if (temp === "partTime" || temp === "test" || temp === "mark") {
            this.$set(this.tableData[index], temp, "FALSE");
          } else if (temp === "score") {
            this.$set(this.tableData[index], temp, "99:99.99");
          } else if (temp !== "schoolName") {
            this.$set(this.tableData[index], temp, "");
          }
        }
      });
      this.editable.filter((item, index) => {
        for (let temp in item) {
          this.$set(this.editable[index], temp, false);
        }
      });
      this.athleteList = [];
      window.scrollTo(0, 0);
    },
    // 获取教练员列表
    getCoachLists() {
      getCoachList({
        project: this.scopeCoach == "all" ? null : 4
      })
        .then(res => {
          this.coachList = [...res];
          res.filter(item => {
            item.disabled = false;
          });
        })
        .catch(err => {});
    },
    // 获取赛事列表
    getMatch() {
      getMatchList({
        project: 4,
        pageNo: 1,
        pageSize: 999
      })
        .then(res => {
          this.matchList = res.list;
          this.isShowBtn = res.list.length === 0 ? false : true;
          this.hideMask = true;
          if (this.$route.query.id) this.selectMatch(this.$route.query.id);
        })
        .catch(err => {
          if (err.data.msg === "当前没有赛事") {
            this.isShowBtn = false;
          }
          this.hideMask = true;
        });
    },
    // 选择赛事
    selectMatch(value) {
      Object.assign(this.query, this.$options.data().query);
      this.scopeAthlete = "all";
      this.scopeCoach = "all";
      this.athleteList = [];
      this.$refs.form.resetFields();
      let data = {};
      this.matchList.filter(item => {
        if (item.id === value) data = item;
      });
      this.currentProject = data;
      this.groupList = [];
      data.groupId.split(",").filter(item => {
        switch (item) {
          case "1": {
            this.groupList.push({
              label: "甲组",
              value: "甲组"
            });
            break;
          }
          case "2": {
            this.groupList.push({
              label: "乙组",
              value: "乙组"
            });
            break;
          }
          case "3": {
            this.groupList.push({
              label: "丙组",
              value: "丙组"
            });
            break;
          }

          default: {
            this.groupList.push({
              label: "丁组",
              value: "丁组"
            });
            break;
          }
        }
      });
      Object.assign(this.query, {
        matchId: data.id,
        raceName: value
      });
      this.getSignDetail(value);
    },
    // 获取当前赛事运动员列表（草稿）
    getAthleteListByDraft() {
      return new Promise((resolve, reject) => {
        getAthleteList({
          pageNo: 1,
          pageSize: 999,
          effective: 1,
          isPass: 1,
          isOld: 0,
          project: this.scopeAthlete == "all" ? null : 4,
          gender:
            this.currentProject.gender === -1 ? "" : this.currentProject.gender
        })
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // 获取详情，如果有数据，则表示已经提交或草稿数据，如果审核已通过，则修改表格显示数量
    getSignDetail(id) {
      getSignDetailBySchool({ matchId: id })
        .then(res => {
          if (res) {
            this.publishState = res.state;
            (this.scopeAthlete = res.scopeAthlete == 1 ? "all" : "swim"),
              (this.scopeCoach = res.scopeCoach == 1 ? "all" : "swim"),
              Object.assign(this.query, {
                id: res.id
              });
            this.getCoachLists();
            this.getAthleteListByDraft()
              .then(data => {
                this.athleteList = [...data.list];
                // 状态为1或者3时，表示审核通过，则渲染提交数据的列数,并且不显示最后一列的添加
                if (res.state === 3)
                  this.makeTable(res.swimAthleteList.length, "pass");
                else if (res.state === 1)
                  this.makeTable(res.swimAthleteList.length, "pass");
                // 其他状态则渲染提交数据的列数
                else this.makeTable(res.swimAthleteList.length);
                /**
                 * 循环list,当身份为1时,则赋值运动员id及其关联项
                 * 身份为2,3,4,5,6(教练员,领队,工作人员,医生,代表队)时,则赋值与其对应项
                 */
                res.swimAthleteList.filter((item, index) => {
                  if (item.identity == 1) {
                    Object.assign(this.tableData[index], {
                      athleteId: item.athleteId,
                      identity: item.identity,
                      coachId: item.coachId,
                      coachName: item.coachName,
                      remarks: item.remarks,
                      distance: item.distance,
                      group: item.group,
                      swimmingStyle: item.swimmingStyle,
                      score: item.score,
                      test: item.test,
                      mark: item.mark
                    });
                    this.selectDistance(item.distance, index);
                    this.selectAthlete(item.athleteId, index, "name", true);
                  } else if (
                    item.identity == 2 ||
                    item.identity == 3 ||
                    item.identity == 4 ||
                    item.identity == 5
                  ) {
                    Object.assign(this.tableData[index], {
                      identity: item.identity,
                      partTime: item.partTime,
                      gender: item.gender,
                      name: item.name,
                      pinyin: item.pinyin,
                      subUnit: item.subUnit,
                      remarks: item.remarks,
                      matchNumber: item.matchNumber,
                      mark: item.mark,
                      test: item.test
                    });
                  } else {
                    Object.assign(this.tableData[index], {
                      identity: item.identity,
                      partTime: item.partTime,
                      gender: item.gender,
                      group: item.group,
                      subUnit: item.subUnit,
                      matchNumber: item.matchNumber,
                      remarks: item.remarks,
                      distance: item.distance,
                      swimmingStyle: item.swimmingStyle,
                      score: item.score,
                      mark: item.mark,
                      test: item.test
                    });

                    this.selectDistance(item.distance, index);
                  }
                });
              })
              .catch(err => {});
          } else {
            this.publishState = 0;
            this.getAthleteLists();
            this.makeTable();
          }
        })
        .catch(err => {});
    },
    // 表格点击显示对应下拉菜单或输入框
    changeNum(index, row, className) {
      this.editable.filter(item => {
        for (let temp in item) item[temp] = false;
      });
      if (this.tableData[index]["isAdd"]) return;
      this.editable[index][row] = true;
      if (
        this.tableData[index][row] === "输入" ||
        this.tableData[index][row] === "非必填项"
      )
        this.$set(this.tableData[index], row, "");
      //让input自动获取焦点
      this.$nextTick(() => {
        var editInputList = document.getElementsByClassName(className);
        // 选择身份时,进入判断
        if (this.tableData[index].identity) {
          // 如果该列身份为领队、教练、工作人员及医生，只允许填写/选择 姓名全拼、备注、测验及特殊标记
          switch (this.tableData[index].identity) {
            case 2:
            case 3:
            case 4:
            case 5: {
              this.genderList = [
                {
                  label: "男子",
                  value: "男子"
                },
                {
                  label: "女子",
                  value: "女子"
                }
              ];
              if (
                row !== "name" &&
                row !== "pinyin" &&
                row !== "remarks" &&
                row !== "mark" &&
                row !== "test" &&
                row !== "identity" &&
                row !== "gender" &&
                row !== "partTime"
              ) {
                this.editable[index][row] = false;
                return;
              } else if (
                row === "pinyin" ||
                row === "remarks" ||
                row === "name"
              ) {
                editInputList[0].children[0].focus();
              } else {
                editInputList[0].children[0].children[0].focus();
              }
              break;
            }
            case 6: {
              this.genderList = this.$options.data().genderList;
              if (
                row === "name" ||
                row === "pinyin" ||
                row === "idCard" ||
                row === "birthday" ||
                row === "registerNumber" ||
                row === "coachId"
              ) {
                this.editable[index][row] = false;
                return;
              } else if (row === "score" || row === "remarks") {
                editInputList[0].children[0].focus();
              } else {
                // 点击项为距离时,若当前已有值,则泳式列表切换对应列表
                if (row === "distance" && this.tableData[index][row]) {
                  this.selectDistance(this.tableData[index][row], index);
                  this.selectSwimmingStyle(
                    this.tableData[index]["swimmingStyle"],
                    index
                  );
                }
                // 当没有值时,重置距离及泳式列表
                else if (
                  row === "distance" &&
                  !this.tableData[index][row] &&
                  !this.tableData[index]["swimmingStyle"]
                ) {
                  this.selectDistance(null, index);
                  this.selectSwimmingStyle(null, index);
                }
                // 当距离没有值，泳式有值时，距离列表切换对应泳式列表
                else if (
                  row === "distance" &&
                  !this.tableData[index][row] &&
                  this.tableData[index]["swimmingStyle"]
                ) {
                  this.selectSwimmingStyle(
                    this.tableData[index]["swimmingStyle"],
                    index
                  );
                }
                // 点击项为距离时,若当前已有值,则距离列表切换对应列表
                if (row === "swimmingStyle" && this.tableData[index][row]) {
                  this.selectDistance(this.tableData[index]["distance"], index);
                  this.selectSwimmingStyle(this.tableData[index][row], index);
                }
                // 当没有值时,重置距离及泳式列表
                else if (
                  row === "swimmingStyle" &&
                  !this.tableData[index][row] &&
                  !this.tableData[index]["distance"]
                ) {
                  this.selectDistance(null, index);
                  this.selectSwimmingStyle(null, index);
                }
                // 当泳式没有值，距离有值时，泳式列表切换对应距离列表
                else if (
                  row === "swimmingStyle" &&
                  !this.tableData[index][row] &&
                  this.tableData[index]["distance"]
                ) {
                  this.selectDistance(this.tableData[index]["distance"], index);
                }
                editInputList[0].children[0].children[0].focus();
              }
              break;
            }
            default: {
              if (
                row === "gender" ||
                row === "pinyin" ||
                row === "idCard" ||
                row === "birthday" ||
                row === "registerNumber"
              ) {
                this.editable[index][row] = false;
                return;
              } else if (row === "score" || row === "remarks") {
                editInputList[0].children[0].focus();
              } else {
                // 点击项为距离时,若当前已有值,则泳式列表切换对应列表
                if (row === "distance" && this.tableData[index][row]) {
                  this.selectDistance(this.tableData[index][row], index);
                  this.selectSwimmingStyle(
                    this.tableData[index]["swimmingStyle"],
                    index
                  );
                }
                // 当距离及泳式都没有值时,重置距离及泳式列表
                else if (
                  row === "distance" &&
                  !this.tableData[index][row] &&
                  !this.tableData[index]["swimmingStyle"]
                ) {
                  this.selectDistance(null, index);
                  this.selectSwimmingStyle(null, index);
                }
                // 当距离没有值，泳式有值时，距离列表切换对应泳式列表
                else if (
                  row === "distance" &&
                  !this.tableData[index][row] &&
                  this.tableData[index]["swimmingStyle"]
                ) {
                  this.selectSwimmingStyle(
                    this.tableData[index]["swimmingStyle"],
                    index
                  );
                }
                // 点击项为距离时,若当前已有值,则距离列表切换对应列表
                if (row === "swimmingStyle" && this.tableData[index][row]) {
                  this.selectDistance(this.tableData[index]["distance"], index);
                  this.selectSwimmingStyle(this.tableData[index][row], index);
                }
                // 当没有值时,重置距离及泳式列表
                else if (
                  row === "swimmingStyle" &&
                  !this.tableData[index][row] &&
                  !this.tableData[index]["distance"]
                ) {
                  this.selectDistance(null, index);
                  this.selectSwimmingStyle(null, index);
                }
                // 当泳式没有值，距离有值时，泳式列表切换对应距离列表
                else if (
                  row === "swimmingStyle" &&
                  !this.tableData[index][row] &&
                  this.tableData[index]["distance"]
                ) {
                  this.selectDistance(this.tableData[index]["distance"], index);
                }
                if (row == "name") {
                  Object.assign(this.showDialog, {
                    isShow: true,
                    title: "选择运动员",
                    type: 1
                  });
                  this.athletes = this.tableData[index].athleteId;
                  this.tableRow = index;
                } else if (row == "coachId") {
                  Object.assign(this.showDialog, {
                    isShow: true,
                    title: "选择教练员",
                    type: 2
                  });
                  this.coachs = this.tableData[index].coachId;
                  this.tableRow = index;
                } else editInputList[0].children[0].children[0].focus();
              }
            }
          }
        } else {
          // 点击项为姓名全拼、身份证、出生日期、注册号码时不予操作（选择人员后自动匹配对应信息）
          if (
            row === "pinyin" ||
            row === "idCard" ||
            row === "registerNumber" ||
            row === "birthday" ||
            row === "distance" ||
            row === "swimmingStyle" ||
            row === "coachId"
          ) {
            this.editable[index][row] = false;
            return;
          } else if (row !== "remarks" && row !== "score")
            editInputList[0].children[0].children[0].focus();
          else editInputList[0].children[0].focus();
        }
      });
    },
    // 选择身份时，清空该行数据,
    selectIdentity(e, index) {
      Object.assign(this.tableData[index], {
        athleteId: "",
        partTime: "FALSE",
        gender: "",
        group: "",
        name: "",
        pinyin: "",
        idCard: "",
        birthday: "",
        registerNumber: "",
        coachId: "",
        remarks: "",
        distance: "",
        swimmingStyle: "",
        score: e == 2 || e == 3 || e == 4 || e == 5 ? "" : "99:99.99",
        test: "FALSE",
        mark: "FALSE"
      });
      this.accordingIdentity(e, index);
      this.sortTable(e, index);
    },
    // 根据身份，并对表格按照领队、教练、工作人员、医生、运动员、代表队进行排序
    sortTable(e, index) {
      let leadList = []; // 领队(3)
      let coachList = []; // 教练(2)
      let personnelList = []; // 工作人员(4)
      let doctorList = []; // 医生(5)
      let athleteList = []; // 运动员(1)
      let representList = []; // 代表队(6)
      let blankList = []; // 空白项
      let matelist = {}; // 选择身份的那行，循环结束，根据选择的身份，添加到对应list的第一个数据。
      this.tableData.slice(0, this.tableData.length - 1).filter((item, num) => {
        switch (item.identity) {
          case 1:
            if (num !== index) athleteList.push(item);
            else matelist = item;
            break;
          case 2:
            if (num !== index) coachList.push(item);
            else matelist = item;
            break;
          case 3:
            if (num !== index) leadList.push(item);
            else matelist = item;
            break;
          case 4:
            if (num !== index) personnelList.push(item);
            else matelist = item;
            break;
          case 5:
            if (num !== index) doctorList.push(item);
            else matelist = item;
            break;
          case 6:
            if (num !== index) representList.push(item);
            else matelist = item;
            break;
          default:
            if (num !== index) representList.push(item);
            else matelist = item;
            break;
        }
      });
      switch (matelist.identity) {
        case 1: {
          athleteList.unshift(matelist);
          break;
        }
        case 2: {
          coachList.unshift(matelist);
          break;
        }
        case 3: {
          leadList.unshift(matelist);
          break;
        }
        case 4: {
          personnelList.unshift(matelist);
          break;
        }
        case 5: {
          doctorList.unshift(matelist);
          break;
        }
        case 6: {
          representList.unshift(matelist);
          break;
        }
        default: {
          blankList.unshift(matelist);
          break;
        }
      }
      const newArr = [
        ...leadList,
        ...coachList,
        ...personnelList,
        ...doctorList,
        ...athleteList,
        ...representList,
        ...blankList,
        this.tableData[this.tableData.length - 1]
      ];
      this.tableData = [...newArr];
    },
    // 根据身份，调整距离及泳式列表内容
    accordingIdentity(e, index) {
      // 判断身份为1时（运动员），距离及泳式列表切换至对应项
      // 身份为6时（代表队），距离及泳式切换至对应项
      switch (e) {
        case 1: {
          this.swimmingStyleList = [
            {
              label: "自由泳",
              value: "自由泳"
            },
            {
              label: "仰泳",
              value: "仰泳"
            },
            {
              label: "蛙泳",
              value: "蛙泳"
            },
            {
              label: "蝶泳",
              value: "蝶泳"
            },
            {
              label: "个人混合泳",
              value: "个人混合泳"
            }
          ];
          this.distanceList = [
            {
              label: "50米",
              value: "50米"
            },
            {
              label: "100米",
              value: "100米"
            },
            {
              label: "200米",
              value: "200米"
            },
            {
              label: "400米",
              value: "400米"
            },
            {
              label: "800米",
              value: "800米"
            },
            {
              label: "1500米",
              value: "1500米"
            }
          ];
          break;
        }
        case 6: {
          this.swimmingStyleList = [
            {
              label: "自由泳接力",
              value: "自由泳接力"
            },
            {
              label: "混合泳接力",
              value: "混合泳接力"
            }
          ];
          this.distanceList = [
            {
              label: "4X50米",
              value: "4X50米"
            },
            {
              label: "4X100米",
              value: "4X100米"
            },
            {
              label: "4X200米",
              value: "4X200米"
            }
          ];
        }
        default:
          break;
      }
    },
    // 选择运动员
    selectAthlete(value, num, col, details = false) {
      if (value) {
        // this.athleteList.filter((item, index) => {
        //   this.$set(this.athleteList[index], "disabled", false);
        // });
        let arr = [];
        if (!details) this.$set(this.tableData[num], "athleteId", "");

        // this.tableData.filter((item, i) => {
        for (let j = 0; j < this.athleteList.length; j++) {
          if (
            this.tableData[num].name === this.athleteList[j].id ||
            this.tableData[num].athleteId === this.athleteList[j].id
          ) {
            // this.$set(this.athleteList[j], "disabled", true);
            this.$set(this.athleteList[j], "numbers", num);
            arr.push(this.athleteList[j]);
            break;
          }
        }
        // });
        arr.filter((item, i) => {
          for (let t in item) {
            if (this.tableData[item.numbers].hasOwnProperty(t)) {
              if (t !== "coachId" && t !== "coachName") {
                if (t === "gender")
                  this.$set(
                    this.tableData[item.numbers],
                    t,
                    item[t] === 0 ? "女子" : "男子"
                  );
                else if (t === "group") {
                } else if (t === "birthday") {
                  this.$set(this.tableData[item.numbers], t, item.birthdayText);
                } else if (t !== "remarks")
                  this.$set(this.tableData[item.numbers], t, item[t]);
              }
            }
            Object.assign(this.tableData[item.numbers], {
              athleteId: item.id,
              pinyin: item.nameSpell
            });
          }
        });
      } else {
        Object.assign(this.tableData[num], {
          group: "",
          pinyin: "",
          idCard: "",
          birthday: "",
          registerNumber: "",
          gender: ""
        });
      }
    },
    // 表格下拉框或输入框离开焦点
    handleBlur(e, index, col) {
      setTimeout(() => {
        /**
         * 当前项为报名成绩时：
         *      若无输入值，赋予默认值
         *      若存在输入值，则判断：
         *            1.输入为6位纯数字且不等于'000000'时，自动每两位后添加分号，输入验证失败，则赋予默认值
         *            2.输入值格式位'numbernumber:numbernumber:number:number'且不等于'00:00:00'时，自动每两位后添加分号，输入验证失败，则赋予默认值
         *  */

        if (col == "score") {
          if (this.tableData[index][col] === "")
            this.$set(this.tableData[index], col, "99:99.99");
          else {
            // 判断1
            if (
              /^\d{6}$/.test(this.tableData[index][col]) &&
              this.tableData[index][col] !== "000000"
            ) {
              let str = this.tableData[index][col];
              let newStr = "";
              for (let item in str) {
                if (item == 1) {
                  newStr += str.slice(item - 1, item - 0 + 1) + ":";
                } else if (item == 3) {
                  newStr += str.slice(item - 1, item - 0 + 1) + ".";
                }
              }
              newStr += str.slice(str.length - 2);
              this.$set(this.tableData[index], col, newStr);
            }
            // 判断2
            else {
              if (
                !/^(\d{1}|[0-9]\d):(\d{1}|[0-9]\d)\.(\d{1}|[0-9]\d)$/.test(
                  this.tableData[index][col]
                ) ||
                this.tableData[index][col] === "00:00.00"
              ) {
                this.openWarn("输入格式错误，已恢复默认设置！");
                this.$set(this.tableData[index], col, "99:99.99");
              } else {
                let arr = this.tableData[index][col].split(":");
                let newArr = [];
                arr.filter(item => {
                  if (item - 0 < 10 && item.length < 2) {
                    newArr.push("0" + item);
                  } else newArr.push(item);
                });
                this.$set(this.tableData[index], col, newArr.join(":"));
              }
            }
          }
        }

        this.editable[index][col] = false;
      }, 200);
    },
    // 根据赛事限制人数生成表格
    makeTable(count = this.currentProject.count, isPass = null) {
      this.tableData = [];
      this.editable = [];
      for (let i = 0; !isPass ? i <= count : i < count; i++) {
        this.tableData.push({
          isAdd: i == count ? true : false,
          schoolName: i == count ? "" : this.userInfo.schoolName,
          athleteId: "",
          identity: "",
          partTime: i == count ? "" : "FALSE",
          gender: "",
          group: "",
          name: "",
          pinyin: "",
          idCard: "",
          birthday: "",
          registerNumber: "",
          matchNumber: "",
          subUnit: "",
          coachId: "",
          coachName: "",
          remarks: "",
          distance: "",
          swimmingStyle: "",
          score: i == count ? "" : "99:99.99",
          test: i == count ? "" : "FALSE",
          mark: i == count ? "" : "FALSE"
        });
        let obj = {};
        this.titles.filter(temp => {
          obj[temp] = false;
        });
        this.editable.push(obj);
      }
    },
    // 选择距离筛选的泳式列表后，判断当前泳式项是否在列表中，如果不在，则清空值
    isContainStyle(index) {
      let flag = false;
      this.swimmingStyleList.filter(item => {
        if (item.value === this.tableData[index].swimmingStyle) {
          flag = true;
        }
      });
      if (!flag) this.$set(this.tableData[index], "swimmingStyle", "");
    },
    // 选择距离后需要筛选对应泳式的列表
    selectDistance(e, index) {
      if (!e) {
        // this.swimmingStyleList = this.$options.data().swimmingStyleList;
        this.accordingIdentity(this.tableData[index]["identity"]);
        return;
      }
      switch (e) {
        case "50米":
        case "100米":
        case "200米":
        case "400米":
        case "800米":
        case "1500米": {
          this.swimmingStyleList = [
            {
              label: "自由泳",
              value: "自由泳"
            },
            {
              label: "仰泳",
              value: "仰泳"
            },
            {
              label: "蛙泳",
              value: "蛙泳"
            },
            {
              label: "蝶泳",
              value: "蝶泳"
            },
            {
              laebl: "个人混合泳",
              value: "个人混合泳"
            }
          ];
          this.isContainStyle(index);
          break;
        }
        case "4X100米": {
          this.swimmingStyleList = [
            {
              label: "自由泳接力",
              value: "自由泳接力"
            },
            {
              label: "混合泳接力",
              value: "混合泳接力"
            }
          ];

          this.isContainStyle(index);
          break;
        }
        case "4X200米": {
          this.swimmingStyleList = [
            {
              label: "自由泳接力",
              value: "自由泳接力"
            }
          ];
          this.isContainStyle(index);
          break;
        }
        case "4X50米": {
          this.swimmingStyleList = [
            {
              label: "混合泳接力",
              value: "混合泳接力"
            }
          ];
          this.isContainStyle(index);
          break;
        }
      }
    },
    // 选择泳式筛选的距离列表后，判断当前距离项是否在列表中，如果不在，则清空值
    isContainDistance(index) {
      let flag = false;
      this.distanceList.filter(item => {
        if (item.value === this.tableData[index].distance) {
          flag = true;
        }
      });
      if (!flag) this.$set(this.tableData[index], "distance", "");
    },
    // 选择泳式后需要筛选对应的距离列表
    selectSwimmingStyle(e, index) {
      if (!e) {
        this.accordingIdentity(this.tableData[index]["identity"]);
        // this.distanceList = this.$options.data().distanceList;
        return;
      }

      switch (e) {
        case "自由泳":
        case "仰泳":
        case "蛙泳":
        case "蝶泳":
        case "个人混合泳": {
          this.distanceList = [
            {
              label: "50米",
              value: "50米"
            },
            {
              label: "100米",
              value: "100米"
            },
            {
              label: "200米",
              value: "200米"
            },
            {
              label: "400米",
              value: "400米"
            },
            {
              label: "800米",
              value: "800米"
            },
            {
              label: "1500米",
              value: "1500米"
            }
          ];
          this.isContainDistance(index);
          break;
        }
        case "自由泳接力": {
          this.distanceList = [
            {
              label: "4X100米",
              value: "4X100米"
            },
            {
              label: "4X200米",
              value: "4X200米"
            }
          ];
          this.isContainDistance(index);
          break;
        }
        case "混合泳接力": {
          this.distanceList = [
            {
              label: "4X50米",
              value: "4X50米"
            },
            {
              label: "4X100米",
              value: "4X100米"
            }
          ];
          this.isContainDistance(index);
          break;
        }
      }
    },
    // 选择性别,当性别为男子或女子时，距离及泳式列表与data里定义数据保持一致，当性别为男女时，距离只有4x50、4x100，泳式只有自由接力、混合接力
    selectGender(e, index) {
      // if (e === "男女") {
      //   this.distanceList = [
      //     {
      //       label: "4X50米",
      //       value: "4X50米"
      //     },
      //     {
      //       label: "4X100米",
      //       value: "4X100米"
      //     }
      //   ];
      //   this.swimmingStyleList = [
      //     {
      //       label: "自由泳",
      //       value: "自由泳"
      //     },
      //     {
      //       label: "个人混合泳",
      //       value: "个人混合泳"
      //     }
      //   ];
      // } else {
      //   Object.assign(this.distanceList, this.$options.data().distanceList);
      //   Object.assign(
      //     this.swimmingStyleList,
      //     this.$options.data().swimmingStyleList
      //   );
      // }
      Object.assign(this.tableData[index], {
        swimmingStyle: "",
        distance: ""
      });
    },
    // 获取当前赛事运动员列表
    getAthleteLists() {
      getAthleteList({
        pageNo: 1,
        pageSize: 999,
        effective: 1,
        isPass: 1,
        isOld: 0,
        gender:
          this.currentProject.gender === -1 ? "" : this.currentProject.gender
      })
        .then(res => {
          if (res.list.length === 0) {
            this.openWarn("当前组别无运动员数据");
          }
          res.list.filter(item => {
            item.disabled = false;
          });
          this.makeTable();
          this.athleteList = [...res.list];
        })
        .catch(err => {});
    }
  },
  mounted() {
    this.getMatch();
    this.getAthleteLists();
    this.getCoachLists();
  }
};
</script>
<style lang="less" scoped>
.application_form {
  /deep/ .el-table {
    .cell {
      padding: 0 5px;
    }
    .show_limmit {
      display: block;
      width: 100%;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
}
footer {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 60px;
  .btns {
    margin: 0;
    color: #1e63b0;
    border: 1px solid #1e63b0;
  }
}
.athlete_range,
.coach_range {
  padding: 0 40px;
  > .heads {
    > span {
      margin-right: 10px;
    }
    margin: 0 0 30px;
  }
  .radio_group {
    margin-bottom: 50px;
    ul {
      display: flex;
      > li {
        margin-right: 20px;
        width: 120px;
        display: flex;
        align-items: center;
        min-height: 40px;
        /deep/ .el-radio {
          display: flex;
          align-items: center;
        }
        /deep/ .el-radio__label {
          word-break: break-all;
          width: 100px;
          white-space: initial;
          line-height: 16px;
        }
      }
    }
  }
}

.dialog-footer {
  display: flex;
  justify-content: center;
  padding-bottom: 20px;
}
</style>